import { Pipe, PipeTransform } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { isImagesBucketAsset } from '../../lib/is-images-bucket-asset';

@Pipe({
  name: 'canWatermarkAsset',
})
export class CanWatermarkAssetPipe implements PipeTransform {
  transform(asset: AssetDto): boolean {
    if (!asset) return false;
    if (asset.type !== 'image') return false;
    if (asset.version_data.status !== 'completed') return false;
    return isImagesBucketAsset(asset, asset.version_data);
  }
}
